import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import CaseDetail from "./CaseDetail";
import useSupportTickets from "../hooks/useSupportTickets";
import {
  clearSupportActionError,
  loadSupportCaseThreadThunk,
  setSelectedSupportCase,
} from "../store/supportSlice";

const ContactSupportCase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    cases,
    selectedCase,
    currentUserName,
    isLoadingCaseThread,
    actionError,
    handleSendReply,
    handleDownloadAttachment,
    handleEditMessage,
    handleDeleteMessage,
    handleOpenCase,
    handleCloseCase,
    handleBackToCases,
  } = useSupportTickets();

  useEffect(() => {
    if (!id) {
      navigate("/support", { replace: true });
      return;
    }

    const caseFromList = cases.find((item) => String(item.id) === String(id));
    dispatch(loadSupportCaseThreadThunk(caseFromList || { id }));

    return () => {
      dispatch(setSelectedSupportCase(null));
      dispatch(clearSupportActionError());
    };
  }, [id, dispatch, navigate]);

  const handleBack = () => {
    handleBackToCases();
    navigate("/support");
  };

  const handleCloseActionError = (_event, reason) => {
    if (reason === "clickaway") return;
    dispatch(clearSupportActionError());
  };

  const isCurrentCase =
    selectedCase && String(selectedCase.id) === String(id);

  return (
    <div className="sm:mx-2 py-4">
      <Snackbar
        open={Boolean(actionError)}
        autoHideDuration={6000}
        onClose={handleCloseActionError}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseActionError}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {actionError}
        </Alert>
      </Snackbar>

      {isLoadingCaseThread && !isCurrentCase ? (
        <div className="rounded-md border border-line bg-white px-4 py-6 text-sm text-muted">
          Loading case details...
        </div>
      ) : isCurrentCase ? (
        <CaseDetail
          caseData={selectedCase}
          currentUserName={currentUserName}
          onBack={handleBack}
          onSendReply={handleSendReply}
          onDownloadAttachment={handleDownloadAttachment}
          onCloseCase={handleCloseCase}
          isLoadingThread={isLoadingCaseThread}
          onOpenCase={handleOpenCase}
          onEditMessage={handleEditMessage}
          onDeleteMessage={handleDeleteMessage}
        />
      ) : actionError ? null : (
        <div className="rounded-md border border-line bg-white px-4 py-6 text-sm text-muted">
          Loading case details...
        </div>
      )}
    </div>
  );
};

export default ContactSupportCase;
